import React, { useState, useRef, RefObject } from 'react';
import {
    ActType,
    IMultiCapabilityTemplateInfo,
    ITemplateComponentProps,
    PanelType,
    VIEW_MODE,
} from '../../../interface/multiCapabilityTemplate';
import { Button } from '@umu/umu-design';
import { lang } from '@umu/ukit-lang';
import { TemplateInfo } from '../../../components/templateInfo';
import ListBlankPC from '../../../../ListBlank/ListBlankPC';
const BodyContent = (props: ITemplateComponentProps) => {
    const [isValid, setIsValid] = useState(false);
    const templateRef: RefObject<HTMLElement> = useRef(null);

    const { templateInfo: defaultTemplateInfo, templateType, editorConfig, previewPanelType = [], onCommunication } = props;
    const [templateInfo, setTemplateInfo] = useState<any>(defaultTemplateInfo);
    const onPreview = () => {
        previewPanelType.push(PanelType.EDIT);
        onCommunication(ActType.UPDATE_PANEL_TYPE, {
            info: {
                panelType: PanelType.PREVIEW,
                isShowBack: true,
                title: lang('预览多维度评价'),
                mode: VIEW_MODE.EDIT,
                previewPanelType: previewPanelType,
                templateInfo,
            },
        });
    };
    const onCheckData = () => {
        setIsValid(true);
        // 页面渲染完成后 获取 templateRef 下是否有 valid-text 样式元素，有则返回false 并滚动到第一个valid-text 到可视区域
        return new Promise((resolve) => {
            requestAnimationFrame(() => {
                if (templateRef.current) {
                    const validTextElement = templateRef.current.querySelector('.valid-text');
                    if (validTextElement) {
                        validTextElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                        return resolve(false);
                    }
                }
                resolve(true);
            });
        });
    };
    const renderHeardContent = () => {
        const isShowHeard = editorConfig?.isShowPreview || !!editorConfig?.title;
        if (!isShowHeard) {
            return null;
        }
        return (
            <div className="capability-flex-col capability-space-between">
                {editorConfig?.title}
                {editorConfig?.isShowPreview && (
                    <Button type="ghost-grey" onClick={onPreview}>
                        {lang('预览')}
                    </Button>
                )}
            </div>
        );
    };
    const onDataChange = (data: IMultiCapabilityTemplateInfo) => {
        setTemplateInfo(data);
    };
    const renderContent = () => {
        return (
            <div className="template-info-editor-zone small-rows">
                {templateInfo ? (
                    <TemplateInfo
                        isValid={isValid}
                        tmpRef={templateRef}
                        info={templateInfo}
                        mode={VIEW_MODE.EDIT}
                        onChange={onDataChange}
                    />
                ) : (
                    <ListBlankPC type={2} className="template-empty-info" title={lang('‘暂无评价标准')} />
                )}
            </div>
        );
    };
    const onCancelClick = () => {
        onCommunication(ActType.PANEL_CANCEL, { info: {} });
    };
    const onPreClick = () => {
        onCommunication(ActType.UPDATE_PANEL_TYPE, {
            info: {
                panelType: PanelType.SELECT_CAPABILITY_DETAIL,
                isShowBack: true,
                previewPanelType: [PanelType.LIST],
            },
        });
    };
    const onSubmitClick = async () => {
        const isAccess = await onCheckData();
        if (!isAccess) {
            return;
        }
        onCommunication(ActType.PANEL_SUBMIT, {
            templateInfo: {
                parent_type: templateInfo.parent_type || templateType,
                templateInfo,
            },
        });
    };
    return (
        <div className="template-info-detail">
            {renderHeardContent()}
            {renderContent()}
            <div className="footer-list capability-flex-col fix-right">
                {editorConfig.isShowCancel && (
                    <Button type="ghost-grey" onClick={onCancelClick}>
                        {lang('取消')}
                    </Button>
                )}
                {editorConfig.isShowPreStep && (
                    <Button type="ghost-grey" className="btn-split" onClick={onPreClick}>
                        {lang('上一步')}
                    </Button>
                )}
                <Button type="primary" className="btn-split" onClick={onSubmitClick}>
                    {lang('确认')}
                </Button>
            </div>
        </div>
    );
};

export const templateEditor = {
    BodyContent,
};
